import { render } from "./FooterBarBelow.vue?vue&type=template&id=0e9dadfb"
import script from "./FooterBarBelow.vue?vue&type=script&lang=js"
export * from "./FooterBarBelow.vue?vue&type=script&lang=js"

import "./FooterBarBelow.vue?vue&type=style&index=0&id=0e9dadfb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__